import React from "react";
import CarePlans from "./CarePlans";
import "./subscription.css";

const SubscriptionPlanV2 = () => <CarePlans />;

export default SubscriptionPlanV2;
